var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishedStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#611BA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6224 11.7801L16.4399 11.2761L14.3813 6.26325C14.2371 5.91225 13.7626 5.91225 13.6185 6.26325L11.5598 11.2761L6.37739 11.7801C6.0145 11.8154 5.86787 12.2887 6.14163 12.541L10.0518 16.1431L8.90749 21.4675C8.82735 21.8403 9.21132 22.1328 9.52466 21.9377L13.9999 19.1511L18.4751 21.9377C18.7885 22.1328 19.1724 21.8403 19.0923 21.4675L17.9479 16.1431L21.8581 12.541C22.1319 12.2887 21.9852 11.8154 21.6224 11.7801Z",
    fill: "#F8B817"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedStep);
export default __webpack_public_path__ + "static/media/finished_step.e2c9c9ea0f94bcb84c42757e04ab520b.svg";
export { ForwardRef as ReactComponent };